import React, { Component } from "react";
import styles from "../PricingWrapper.module.scss";
import Grid from "@material-ui/core/Grid";
import ModelDropDown from "./ModelDropDown";
import YearDropDown from "./YearDropDown";
import ExportAll from "./ExportAll";

class PricingSubNav extends Component {
  render() {
    return (
      <div className={`${styles.left} pagePaddingLeft pagePaddingBottom`}>
        {this.props.selectedTab === 0 ? (
          <div>
            <div className={styles.dealerTrans}>
              <p>{this.props.t("DealerFees.subHeader")} </p>
              {this.props.user.showPricingWarningMessage && (
                <p className={styles.warningMessage}>
                  {this.props.t("DealerFees.priceChangeWarning")}
                </p>
              )}
            </div>
            <div className={styles.modelDiv}>
              <div className={styles.dropdownContainer}>
                <Grid item md={3} xs={4}>
                  <div className={styles.subTitle}>
                    {this.props.t("NamePlate.model")}
                  </div>
                  <ModelDropDown
                    {...this.props.props}
                    modelData={this.props.modelData}
                    selectedModel={this.props.selectedModel}
                    modelDropDownValues={this.props.modelDropDownValues}
                    updateModel={this.props.updateModel}
                  />
                </Grid>

                <Grid item md={3} xs={4}>
                  <div className={styles.subTitle}>
                    {this.props.t("NamePlate.modelYear")}
                  </div>
                  <YearDropDown
                    {...this.props.props}
                    yearValues={this.props.yearValues}
                    updateYear={this.props.updateYear}
                    selectedYear={this.props.selectedYear}
                    showAll={this.props.showAll}
                  />
                </Grid>
                <Grid item md={5} xs={3} />
                <Grid item md={1} xs={1} className={styles.exportAllDiv}>
                  <ExportAll
                    {...this.props}
                    feesData={this.props.feesData}
                    pricingData={this.props.pricingData}
                    optionsData={this.props.optionsData}
                    selectedModel={this.props.selectedModel}
                    selectedYear={this.props.selectedYear}
                  />
                </Grid>
              </div>
            </div>
          </div>
        ) : this.props.selectedTab === 1 ? (
          <>
            <div className={styles.dealerTrans}>
              {this.props.t("DealerVehicles.subheader1")}
            </div>
            <div className={styles.equation}>
              {this.props.t("DealerVehicles.rrp")}{" "}
              <span className={styles.minus}> &#8722; </span>{" "}
              {this.props.t("DealerVehicles.variableMarketingOffer")}
              <span className={styles.plus}> &#43;/&#8722; </span>{" "}
              {this.props.t("DealerVehicles.dealerAdjustment")}
              <span className={styles.equal}> &#61; </span>{" "}
              {this.props.t("DealerVehicles.vehicle1")}
            </div>
            <div className={styles.equation}>
              {this.props.t("DealerVehicles.vehicle2")}
              <span className={styles.plus}> &#43; </span>
              {this.props.t("DealerVehicles.dealerFees")}{" "}
              <span className={styles.equal}> &#61; </span>{" "}
              {this.props.t("DealerVehicles.transactionPrice")}
            </div>
            <div className={styles.modelDiv}>
              <div className={styles.dropdownContainer}>
                <Grid item md={3} xs={4}>
                  <div className={styles.subTitle}>
                    {this.props.t("NamePlate.model")}
                  </div>
                  <ModelDropDown
                    {...this.props.props}
                    modelData={this.props.modelData}
                    selectedModel={this.props.selectedModel}
                    modelDropDownValues={this.props.modelDropDownValues}
                    updateModel={this.props.updateModel}
                  />
                </Grid>

                <Grid item md={3} xs={4}>
                  <div className={styles.subTitle}>
                    {this.props.t("NamePlate.modelYear")}
                  </div>
                  <YearDropDown
                    {...this.props.props}
                    yearValues={this.props.yearValues}
                    updateYear={this.props.updateYear}
                    selectedYear={this.props.selectedYear}
                    showAll={this.props.showAll}
                  />
                </Grid>
                <Grid item md={5} xs={3} />
                <Grid item md={1} xs={1} className={styles.exportAllDiv}>
                  <ExportAll
                    {...this.props}
                    feesData={this.props.feesData}
                    pricingData={this.props.pricingData}
                    optionsData={this.props.optionsData}
                    selectedModel={this.props.selectedModel}
                    selectedYear={this.props.selectedYear}
                  />
                </Grid>
              </div>
            </div>
          </>
        ) : (
          <div className={styles.dealerTrans}>
            <p>{this.props.t("DealerVehicles.setAccessoriesPricing")}</p>
            <div className={styles.modelDiv}>
              <div className={styles.dropdownContainer}>
                <Grid item md={3} xs={4}>
                  <div className={styles.subTitle}>
                    {this.props.t("NamePlate.model")}
                  </div>
                  <ModelDropDown
                    {...this.props.props}
                    modelData={this.props.modelData}
                    selectedModel={this.props.selectedModel}
                    modelDropDownValues={this.props.modelDropDownValues}
                    updateModel={this.props.updateModel}
                  />
                </Grid>

                <Grid item md={3} xs={4}>
                  <div className={styles.subTitle}>
                    {this.props.t("NamePlate.modelYear")}
                  </div>
                  <YearDropDown
                    {...this.props.props}
                    yearValues={this.props.yearValues}
                    updateYear={this.props.updateYear}
                    selectedYear={this.props.selectedYear}
                    showAll={this.props.showAll}
                  />
                </Grid>
                <Grid item md={5} xs={3} />
                <Grid item md={1} xs={1} className={styles.exportAllDiv}>
                  <ExportAll
                    {...this.props}
                    feesData={this.props.feesData}
                    pricingData={this.props.pricingData}
                    optionsData={this.props.optionsData}
                    selectedModel={this.props.selectedModel}
                    selectedYear={this.props.selectedYear}
                  />
                </Grid>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default PricingSubNav;
